import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { peopleCountRule } from '../rules';

export const PeopleCountFormItem = () => {
  const { t } = useTranslation();

  return (
    <Form.Item
      label={t('People count')}
      name="peopleCount"
      rules={[peopleCountRule()]}
    >
      <Input type="number" min="0" max="200" />
    </Form.Item>
  );
};
